'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analyticsRevenue = require('./analytics-revenue.component');

var _analyticsRevenue2 = _interopRequireDefault(_analyticsRevenue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics-revenue', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analyticsRevenue', {
    url: '/analytics-revenue',
    template: '<analytics-revenue></analytics-revenue>'
  });
}).component('analyticsRevenue', _analyticsRevenue2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-revenue/analytics-revenue.js
 **/